import Data from "../types/Data";

export default function everyReceiptHasNonZeroTotal(data: Data) {
  return data.receiptIds.every((id) => data.Receipt[id].total > 0);
}
